import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getMakeUpSessionRequest: ["children_id"],
  getMakeUpSessionSuccess: ["leavedatacancel"],
  getMakeUpSessionFailure: null,
});

export const GetMakeUpSessionTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  children_id: null,
  leavedatacancel: null,
});

export const GetMakeUpSessionSelectors = {
  getData: (state: any) => state.getMakeUpSession.data,
  isFetching: (state: any) => state.getMakeUpSession.fetching,
  isSuccess: (state: any) => state.getMakeUpSession.success,
  hasError: (state: any) => state.getMakeUpSession.error,
};

export const request = (state: any, { children_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    children_id,
    leavedatacancel: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { leavedatacancel } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    leavedatacancel,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    leavedatacancel: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_MAKE_UP_SESSION_REQUEST]: request,
  [Types.GET_MAKE_UP_SESSION_SUCCESS]: success,
  [Types.GET_MAKE_UP_SESSION_FAILURE]: failure,
});
